import {defineMessages} from 'react-intl';

const messages = defineMessages({
  account: {
    id: 'crypto.payins.account',
    description: 'Label for the account section',
    defaultMessage: 'Account',
  },
  somethingWentWrong: {
    id: 'crypto.payins.something_went_wrong_v2',
    defaultMessage: 'Something went wrong',
  },
  processing: {
    id: 'crypto.payins.processing_v2',
    defaultMessage: 'Processing...',
  },
  success: {
    id: 'crypto.payins.success_v2',
    defaultMessage: 'Success',
  },
  yourPurchaseIsComplete: {
    id: 'crypto.payins.your_purchase_is_complete_v2',
    defaultMessage: 'Your purchase is complete',
  },
  paymentMethodSavedSubtitle: {
    id: 'crypto.payins.payment_method_saved_subtitle',
    defaultMessage:
      'Payment method saved and authorized! Your payment will be settled according to the payment date.',
  },
  redirectToReturnUrl: {
    id: 'crypto.payins.redirect_to_return_url',
    defaultMessage: 'Return to {businessName}',
  },
  failed: {
    id: 'crypto.payins.failed_v2',
    defaultMessage: 'Failed',
  },
  yourPurchaseFailed: {
    id: 'crypto.payins.your_purchase_failed_v2',
    defaultMessage: 'Your purchase failed',
  },
  savePaymentFailed: {
    id: 'crypto.payins.savePaymentFailed',
    defaultMessage: 'Your payment method could not be saved.',
  },
  signInContinue: {
    id: 'crypto.payins.link.sign_in_continue_v2',
    defaultMessage: 'Continue',
  },
  linkContinue: {
    id: 'crypto.payins.link.link_continue',
    defaultMessage: 'Continue',
  },
  signUp: {
    id: 'crypto.payins.link.sign_up_or_login_v2',
    defaultMessage: 'Sign up',
  },
  signingUp: {
    id: 'crypto.payins.link.signing_up',
    description: "Loading message when signing up a user's account",
    defaultMessage: 'Signing up',
  },
  firstNameLabel: {
    id: 'crypto.payins.link.first_name_label',
    description: "Prompt to confirm the user's first name",
    defaultMessage: 'First name',
  },
  lastNameLabel: {
    id: 'crypto.payins.link.last_name_label',
    description: "Prompt to confirm the user's last name",
    defaultMessage: 'Last name',
  },
  confirmPhone: {
    id: 'crypto.payins.link.confirm_phone_v2',
    defaultMessage: 'Confirm phone number',
  },
  confirmItsYou: {
    id: 'crypto.payins.link.confirm_its_you',
    description: "Prompt to confirm the user's identity",
    defaultMessage: "Confirm it's you",
  },
  confirmYourInformation: {
    id: 'crypto.payins.link.confirm_your_information',
    defaultMessage: 'Confirm your information',
  },
  provideLegalName: {
    id: 'crypto.payins.link.provide_legal_name',
    description: "Prompt to provide the user's legal name",
    defaultMessage: 'Provide your legal name',
  },
  emailLabel: {
    id: 'crypto.payins.link.email_label',
    defaultMessage: 'Email',
  },
  phoneNumberLabel: {
    id: 'crypto.payins.link.phone_number_label',
    defaultMessage: 'Phone',
  },
  confirmPhoneNumberPrompt: {
    id: 'crypto.payins.link.confirm_phone_number_prompt',
    description: 'Prompt to confirm phone number during signup',
    defaultMessage: 'Please confirm your phone number.',
  },
  confirmFirstLast: {
    id: 'crypto.payins.link.confirm_first_last_v3',
    defaultMessage: 'Continue',
  },
  availableInYourWalletLabel: {
    id: 'crypto.payins.available_in_your_wallet_label',
    description:
      "Button label to display what cryptocurrency currencies are available in a user's cryptocurrency wallet",
    defaultMessage: 'Available in your wallet',
  },
  connectButtonLabel: {
    id: 'crypto.payins.connect_button_label',
    description: 'Button label to connect cryptocurrency wallet.',
    defaultMessage: 'Connect',
  },
  connectedLabel: {
    id: 'crypto.payins.connected_label',
    description: 'Label indicating a connected cryptocurrency wallet',
    defaultMessage: 'Connected',
  },
  disconnectButtonLabel: {
    id: 'crypto.payins.disconnect_button_label',
    description: 'Button label to disconnect cryptocurrency wallet.',
    defaultMessage: 'Disconnect',
  },
  metamaskWalletDisconnectTooltip: {
    id: 'crypto.payins.metamask_wallet_disconnect_tooltip',
    description:
      'Message displayed to user if they attempt to connect a new MetaMask cryptocurrency wallet while already connected to one.',
    defaultMessage:
      'Connecting to MetaMask may disconnect your current MetaMask wallet.',
  },
  walletLabel: {
    id: 'crypto.payins.wallet_label',
    description:
      'Label for the selected wallet on a given cryptocurrency network (i.e. solana, ethereum)',
    defaultMessage: '{network} wallet',
  },
  verifyOtp: {
    id: 'crypto.payins.link.verify_otp_v2',
    defaultMessage: 'Verify one-time passcode',
  },
  continueWithLink: {
    id: 'crypto.payins.link.continue_with_link',
    description:
      "Screen header label when user is asked to continue with Stripe's Link product to sign up or log in.",
    defaultMessage: 'Continue with Link',
  },
  manageAccount: {
    id: 'crypto.payins.link.manage_account',
    description: 'Button label to manage account on Link.com',
    defaultMessage: 'Manage account',
  },
  linkTermsOfServiceAndPrivacyPolicy: {
    id: 'crypto.payins.link.link_terms_of_service_and_privacy_policy',
    description:
      "Message displayed to user when they are asked to agree to the Stripe's Link product Terms of Service and Privacy Policy",
    defaultMessage:
      'By continuing, you agree to the Link <LinkTos>Terms</LinkTos> and <LinkPrivacyPolicy>Privacy Policy</LinkPrivacyPolicy>.',
  },
  loginOrSignup: {
    id: 'crypto.payins.link.login_or_signup',
    description:
      "Screen header label when user is asked to continue with Stripe's Link product to sign up or log in.",
    defaultMessage: 'Log in or sign up to continue.',
  },
  logout: {
    id: 'crypto.payins.link.logout_v2',
    defaultMessage: 'Logout',
  },
  logoutOfLink: {
    id: 'crypto.payins.link.logout_of_link',
    description: 'Button label to log out of the Link product',
    defaultMessage: 'Log out of Link',
  },
  networkFee: {
    id: 'crypto.payins.network_fee_v2',
    defaultMessage: 'Network fee',
  },
  notYouLabel: {
    id: 'crypto.payins.not_you_label',
    description:
      'Button label to indicate signed in user is not the current user',
    defaultMessage: 'Not you?',
  },
  total: {
    id: 'crypto.payins.total_v2',
    defaultMessage: 'Total',
  },
  payText: {
    id: 'crypto.payins.pay_text_v3',
    defaultMessage: 'Pay {amount} {currency}',
  },
  payBusiness: {
    id: 'crypto.payins.pay_business_v2',
    description: 'Header for the payment screen',
    defaultMessage: 'Pay {businessName}',
  },
  payBusinessWithCurrency: {
    id: 'crypto.payins.pay_business_with_currency',
    description: 'Header for the payment screen when a currency is selected',
    defaultMessage: ' Pay {businessName} with {currency}',
  },
  error404: {
    id: 'crypto.payins.error_404_v2',
    defaultMessage:
      'Oops! The link you have followed is as missing as Satoshi Nakamoto.',
  },
  error410: {
    id: 'crypto.payins.error_410_v2',
    defaultMessage:
      'Oops! This link has expired due to inactivity. Please go back and try again.',
  },
  unexpectedError: {
    id: 'crypto.payins.unexpected_error_v2',
    defaultMessage: 'Unexpected status: {status}',
  },
  noDataError: {
    id: 'crypto.payins.no_data_error_v2',
    defaultMessage: 'No data found!',
  },
  payWithCrypto: {
    id: 'crypto.payins.pay_with_crypto_v2',
    defaultMessage: 'Pay with crypto',
  },
  connectWallet: {
    id: 'crypto.payins.connect_wallet_v2',
    defaultMessage: 'Connect wallet',
  },
  selectWallet: {
    id: 'crypto.payins.select_wallet_v2',
    defaultMessage: 'Select a connected wallet',
  },
  connectNewWallet: {
    id: 'crypto.payins.connect_new_wallet_v2',
    defaultMessage: 'Connect new wallet',
  },
  selectCurrency: {
    id: 'crypto.payins.select_currency_v2',
    defaultMessage: 'Select a currency',
  },
  signUpOrLogin: {
    id: 'crypto.payins.sign_up_or_login_v2',
    defaultMessage: 'Sign up or login to Link',
  },
  otherLabel: {
    id: 'crypto.payins.other_label',
    description: "Label for 'Other' option in a list",
    defaultMessage: 'Other',
  },
  otherWallets: {
    id: 'crypto.payins.other_wallets_v2',
    defaultMessage: 'Other wallets',
  },
  otherSavedWallets: {
    id: 'crypto.payins.other_saved_wallets',
    description:
      "Label for a list of the user's other saved cryptocurrency wallets",
    defaultMessage: 'Other saved wallets',
  },
  enterCodeSentTo: {
    id: 'crypto.payins.enter_code_sent_to',
    description: "Prompt to enter the code sent to the user's phone number",
    defaultMessage: 'Enter the code sent to {phoneNumber}',
  },
  incompleteEmail: {
    id: 'crypto.payins.incomplete_email_v2',
    defaultMessage: 'Please enter a valid email',
  },
  invalidEmail: {
    id: 'crypto.payins.invalid_email_v2',
    defaultMessage: 'Invalid email address',
  },
  invalidPhoneNumber: {
    id: 'crypto.payins.invalid_phone_number_v2',
    defaultMessage: 'Invalid phone number',
  },
  invalidName: {
    id: 'crypto.payins.invalid_name_v2',
    defaultMessage: 'Please enter a valid name',
  },
  invalidOtp: {
    id: 'crypto.payins.invalid_otp_v2',
    defaultMessage: 'Please enter a valid OTP code',
  },
  testnetBadge: {
    id: 'crypto.payins.testnet_badge',
    description:
      'Badge description when a user is using a cryptocurrency network on the testnet (https://en.wikipedia.org/wiki/Testnet)',
    defaultMessage: 'Testnet',
  },
  testnetDescription: {
    id: 'crypto.payins.testnet_description',
    description:
      'Description when a user is using a cryptocurrency network on the testnet (https://en.wikipedia.org/wiki/Testnet)',
    defaultMessage: 'You are on testnet',
  },
  transactionSendingError: {
    id: 'crypto.payins.transaction_sending_error',
    defaultMessage:
      'There was an error sending your transaction. Please try again or <Link>contact support</Link>.',
  },
  walletConnectedToAnotherAccount: {
    id: 'crypto.payins.wallet_connected_to_another_account_v2',
    defaultMessage:
      'This wallet is connected to another Link account, please connect another wallet.',
  },
  walletAndCurrencyNetworkMismatch: {
    id: 'crypto.payins.wallet_and_currency_network_mismatch_v2',
    defaultMessage:
      'This wallet does not support the selected currency network. Please change the currency or wallet.',
  },
  walletUnsupported: {
    id: 'crypto.payins.walletUnsupported',
    defaultMessage:
      'There was an issue completing your transaction with this wallet. Please try again with another wallet.',
  },
  walletTemporarilyDisabled: {
    id: 'crypto.payins.wallet_temporarily_disabled',
    defaultMessage:
      'This wallet is currently unavailable. Please try connecting a different wallet.',
  },
  genericPaymentError: {
    id: 'crypto.payins.generic_payment_error',
    defaultMessage:
      'There was an error completing your transaction. Please try again.',
  },
  paymentCanceled: {
    id: 'crypto.payins.payment_canceled_v2',
    defaultMessage: 'Your payment has expired. Please try again.',
  },
  volumeLimitExceeded: {
    id: 'crypto.payins.payment_volume_exceeded',
    defaultMessage:
      'You have exceeded the monthly volume limits for paying with Crypto.',
  },
  volumeLimitAnotherPaymentMethod: {
    id: 'crypto.payins.payment_volume_another_payment_method',
    defaultMessage: 'Please use another payment method.',
  },
  linkRetry: {
    id: 'crypto.payins.link_retry',
    defaultMessage: 'Something went wrong. Please try again.',
  },
  verifyWallet: {
    id: 'crypto.payins.verify_wallet_v2',
    defaultMessage: 'Verify wallet',
  },
  verifyingWallet: {
    id: 'crypto.payins.verifying_wallet_v2',
    defaultMessage: 'Verifying wallet',
  },
  signMessage: {
    id: 'crypto.payins.sign_message_v2',
    defaultMessage: 'Sign message on wallet',
  },
  lookingUpWallet: {
    id: 'crypto.payins.looking_up_wallet_v2',
    defaultMessage: 'Looking up wallet',
  },
  lookingUpEmail: {
    id: 'crypto.payins.looking_up_email',
    description: "Loading message when looking up a user's email",
    defaultMessage: 'Looking up email',
  },
  confirming: {
    id: 'crypto.payins.confirming',
    description: "Loading message when confirming a user's input form",
    defaultMessage: 'Confirming',
  },
  verifyingCode: {
    id: 'crypto.payins.verifying_code',
    description:
      "Loading message when verifying a user's one-time passcode (OTP)",
    defaultMessage: 'Verifying code',
  },
  testmodeBadgeLabel: {
    id: 'crypto.payins.testmode_badge_label',
    description:
      'Badge to alert merchants they are in the testmode environment',
    defaultMessage: 'TEST MODE',
  },
  ethereumTransactionTimeWarning: {
    id: 'crypto.payins.ethereum_transaction_time_warning',
    description:
      'Warning label to alert users that Ethereum transactions may take a longer time to process',
    defaultMessage:
      'Transactions on the Ethereum network may take longer to process.',
  },
  usdCoin: {
    id: 'crypto.payins.usd_coin',
    description:
      'Label for the USD Coin cryptocurrency: https://en.wikipedia.org/wiki/USD_Coin',
    defaultMessage: 'USD Coin',
  },
  paxDollar: {
    id: 'crypto.payins.pax_dollar',
    description: 'Label for the USDP cryptocurrency: https://paxos.com/usdp/',
    defaultMessage: 'Pax Dollar',
  },
  usdgCoin: {
    id: 'crypto.payins.usdg_coin',
    description:
      'Label for the USDG cryptocurrency: https://globaldollar.com/global-dollar',
    defaultMessage: 'USDG Coin',
  },
  cashCoin: {
    id: 'crypto.payins.cash_coin',
    description: 'Label for the CASH cryptocurrency',
    defaultMessage: 'Phantom Cash',
  },
  availableBalance: {
    id: 'crypto.payins.available_balance',
    description:
      "Label for the available balance in a user's cryptocurrency wallet",
    defaultMessage: 'Available: {formattedAmount}',
  },
  confirmingTransactionOnChain: {
    id: 'crypto.payins.confirming_transaction_on_chain',
    description:
      'Message displayed to user when their cryptocurrency transaction is being confirmed by the blockchain.',
    defaultMessage:
      'Your <TransactionLink>payment</TransactionLink> is going through the chain',
  },
  confirmingTransactionOnChainTakingLonger: {
    id: 'crypto.payins.confirming_transaction_on_chain_longer',
    description:
      'Message displayed to user when their cryptocurrency transaction is being confirmed by the blockchain and taking longer than expected.',
    defaultMessage:
      'Your <TransactionLink>payment</TransactionLink> is taking longer than expected to go through the chain.',
  },
  confirmTransactionOnWallet: {
    id: 'crypto.payins.confirm_transaction_on_wallet',
    description:
      'Message displayed to user when their cryptocurrency transaction is being confirmed by their wallet.',
    defaultMessage: 'Please confirm the transaction in your wallet.',
  },
  doNotClosePageWarning: {
    id: 'crypto.payins.do_not_close_page_warning',
    description:
      'Warning message to user to not close the page while their transaction is being processed',
    defaultMessage: 'DO NOT refresh or close your browser!',
  },
  insufficientBalance: {
    id: 'crypto.payins.insufficient_balance',
    defaultMessage: 'Insufficient balance',
  },
  unsupportedNetwork: {
    id: 'crypto.payins.unsupported_network',
    defaultMessage:
      'You attempted to connect an unsupported network. Please try again with Ethereum, Polygon, Base, or Solana.',
  },
  cancelToast: {
    id: 'crypto.payins.toast.cancel',
    defaultMessage: 'Cancel',
  },
  setupFutureUsageDisclaimer: {
    id: 'crypto.payins.setup_future_usage_disclaimer',
    defaultMessage:
      'By confirming your payment, you allow {businessName} to charge your wallet for this payment and future payments in accordance with their terms.',
  },
  savePaymentMethodButton: {
    id: 'crypto.payins.save_payment_method.button',
    defaultMessage: 'Save and continue',
  },
  addPaymentMethodHeader: {
    id: 'crypto.payins.add_payment_method.header',
    defaultMessage: 'Add payment method',
  },
  testmodeNotice: {
    id: 'crypto.payins.testmode.notice',
    defaultMessage:
      'Verification codes are not sent in testmode. Use the code 000000 to successfully continue.',
  },
  transactionRejected: {
    id: 'crypto.payins.transaction_rejected',
    defaultMessage:
      'The transaction was rejected. If you still wish to complete your payment, please try again.',
  },
  transactionSigningAbandoned: {
    id: 'crypto.payins.transaction_signing_abandoned',
    defaultMessage:
      'You have canceled the transfer request from your wallet. If you still wish to complete your payment, please try again.',
  },
  transactionSigningExpired: {
    id: 'crypto.payins.transaction_signing_expired',
    defaultMessage:
      'The transfer request has expired. If you still wish to complete your payment, please try again.',
  },
  transactionSigningNetworkError: {
    id: 'crypto.payins.transaction_signing_network_error',
    defaultMessage:
      'There was a network error while signing the transaction. If you still wish to complete your payment, please try again.',
  },
  walletVerificationError: {
    id: 'crypto.payins.wallet_verification_error',
    defaultMessage:
      'We couldn’t verify your wallet. Please try again. If you’re using a smart wallet, try connecting an externally owned account (EOA) instead.',
  },
});
export default messages;
